<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M10.999999940395355,9C10.999999940395355,9,6.999999940395355,9,6.999999940395355,9C6.449999940395355,9,5.999999940395355,9.45,5.999999940395355,10C5.999999940395355,10,5.999999940395355,13,5.999999940395355,13C5.999999940395355,13.55,6.449999940395355,14,6.999999940395355,14C6.999999940395355,14,10.999999940395355,14,10.999999940395355,14C11.549999940395356,14,11.999999940395355,13.55,11.999999940395355,13C11.999999940395355,13,11.999999940395355,10,11.999999940395355,10C11.999999940395355,9.45,11.549999940395356,9,10.999999940395355,9C10.999999940395355,9,10.999999940395355,9,10.999999940395355,9ZM14.999999940395355,0C14.449999940395355,0,13.999999940395355,0.45,13.999999940395355,1C13.999999940395355,1,13.999999940395355,15,13.999999940395355,15C13.999999940395355,15.55,14.449999940395355,16,14.999999940395355,16C15.549999940395356,16,15.999999940395355,15.55,15.999999940395355,15C15.999999940395355,15,15.999999940395355,1,15.999999940395355,1C15.999999940395355,0.45,15.549999940395356,0,14.999999940395355,0C14.999999940395355,0,14.999999940395355,0,14.999999940395355,0ZM10.999999940395355,2C10.999999940395355,2,1.9999999403953552,2,1.9999999403953552,2C1.4499999403953552,2,0.9999999403953552,2.45,0.9999999403953552,3C0.9999999403953552,3,0.9999999403953552,6,0.9999999403953552,6C0.9999999403953552,6.55,1.4499999403953552,7,1.9999999403953552,7C1.9999999403953552,7,10.999999940395355,7,10.999999940395355,7C11.549999940395356,7,11.999999940395355,6.55,11.999999940395355,6C11.999999940395355,6,11.999999940395355,3,11.999999940395355,3C11.999999940395355,2.45,11.549999940395356,2,10.999999940395355,2C10.999999940395355,2,10.999999940395355,2,10.999999940395355,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentRight',
} as DefineComponent
</script>
